import type { ColumnDef } from '@tanstack/react-table';
import { Badge } from '@/components/ui/badge';
import type { Organization } from '../../types';
import { OrganizationActions } from '../OrganizationActions/OrganizationActions';

interface GetColumnsOptions {
  onEdit?: (organization: Organization) => void;
}

export const getOrganizationColumns = (options: GetColumnsOptions = {}): ColumnDef<Organization>[] => [
  {
    accessorKey: 'name',
    header: 'Name',
    cell: ({ row }) => (
      <div data-testid={`org-name-${row.original.id}`}>
        <p className="font-medium">{row.original.name}</p>
      </div>
    ),
  },
  {
    accessorKey: 'venue_count',
    header: 'Venues',
    cell: ({ row }) => (
      <div data-testid={`org-venue-count-${row.original.id}`}>
        {row.original.venue_count}
      </div>
    ),
  },
  {
    accessorKey: 'is_active',
    header: 'Status',
    cell: ({ row }) => {
      const isActive = row.original.is_active;
      return (
        <Badge
          variant={isActive ? 'default' : 'secondary'}
          data-testid={`org-status-${row.original.id}`}
          className={isActive ? 'bg-green-100 text-green-800' : ''}
        >
          {isActive ? 'Active' : 'Inactive'}
        </Badge>
      );
    },
  },
  {
    id: 'actions',
    cell: ({ row }) => (
      <OrganizationActions 
        organization={row.original} 
        onEdit={options.onEdit}
      />
    ),
    size: 50,
    meta: {
      align: 'right',
    },
  },
];
